import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;